import {FC} from 'react'
import {Flex, Skeleton} from 'antd'

interface ButtonsSkeletonProps {

}

const ButtonsSkeleton: FC<ButtonsSkeletonProps> = ({}) => {

    return (
        <Flex gap="16px" justify={'space-between'} className={'modal-word-card__button-area'}>
            {/* Две большие кнопки */}

            <Skeleton.Button
                active
                style={{width: 180, borderRadius: 8}}
            />
            <Flex gap="16px" justify={'flex-end'}>
                <Skeleton.Button
                    active
                    style={{width: 180, borderRadius: 8}}
                />

                {/* Остальные квадратные */}
                <Skeleton.Button
                    active
                    style={{width: 6}}
                />
                <Skeleton.Button
                    active
                    style={{width: 6}}
                />
                <Skeleton.Button
                    active
                    style={{width: 6}}
                />
            </Flex>
        </Flex>
    )
}

export default ButtonsSkeleton